import React from 'react'
import HeroFilterDesktop from './HeroFilterDesktop';

const HeroDesktop = () => {
    return (
        <section className="home1-overlay home1_bgi1">
          <div className="container" style={{height:"100%"}}>
            <div className="row posr" style={{height:"100%"}}>
              <div className="col-lg-12">
                <HeroFilterDesktop />
              </div>
            </div>
          </div>
          {/* End .container */}
        </section>
    
      )
}

export default HeroDesktop;
